<template lang="pug">
    div.tags-view
        scroll-pane(
            class="tags-view-wrapper"
            ref="scrollPane"
            overflow="visible"
        )
            //- @contextmenu.prevent.native="openMenu(tag, $event)"
            router-link(
                ref="tag"
                class="tags-view-item"
                draggable="false"
                v-for="tag in visitedViews"
                :to="tag.realPath"
                :key="tag.name"
                @contextmenu.prevent.native
            )
                span {{ tag.title }}
                i(
                    :class="{ 'el-icon-close': true, 'disabled': visitedViews.length < 2 }"
                    @click.prevent.stop="closeSelectedTag(tag)"
                )

        //- //- 自定义右键菜单
        //- ul(
        //-     class="contextmenu"
        //-     v-show="visible"
        //-     :style="{ left: `${left}px`, top: `${top}px` }"
        //- )
        //-     li(click="closeSelectedTag(selectedTag)") {{ $t("common.tagsView.closeCurrent") }}
        //-     li(@click="closeOthersTags") {{ $t("common.tagsView.closeOther") }}
        //-     li(@click="closeAllTags") {{ $t("common.tagsView.closeAll") }}
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ScrollPane from '@/components/ScrollPane';

export default {
    name: 'TagsView',
    components: { ScrollPane },
    data() {
        return {
            // // 自定义右键菜单
            // visible: false,
            // top: 0,
            // left: 0,

            // 当前选中的标签
            selectedTag: {},
        };
    },
    computed: {
        ...mapState('tagsView', {
            visitedViews: state => state.visitedViews,
        }),
    },
    watch: {
        $route() {
            this.addViewTags();
            this.moveToCurrentTag();
        },
        // visible(value) {
        //     if (value) {
        //         document.body.addEventListener('click', this.closeMenu);
        //         window.addEventListener('resize', this.closeMenu);
        //     } else {
        //         document.body.removeEventListener('click', this.closeMenu);
        //         window.removeEventListener('resize', this.closeMenu);
        //     }
        // },
    },
    mounted() {
        this.addViewTags();
    },
    methods: {
        ...mapActions('tagsView', [
            'AddVisitedViews',
            'DelVisitedViews',
            // 'DelOthersViews',
            // 'DelAllViews',
        ]),
        // 生成路由对象
        generateRoute() {
            if (this.$route.name) return this.$route;
            return false;
        },
        isActive(route) {
            let firstLevel = this.$route;

            // 只缓存一级路由，AppMain.vue中的router-view.body-container
            // eslint-disable-next-line
                if (this.$route.matched && this.$route.matched[1]) firstLevel = this.$route.matched[1];

            return route.name === firstLevel.name;
        },
        // 增加标签
        addViewTags() {
            const route = this.generateRoute();
            if (route) this.AddVisitedViews(route);
        },
        // 位移到选中标签
        moveToCurrentTag() {
            const tags = this.$refs.tag;
            this.$nextTick(() => {
                tags.some((tag) => {
                    if (tag.to === this.$route.fullPath) {
                        this.$refs.scrollPane.moveToTarget(tag.$el);
                        return true;
                    }
                    return false;
                });
            });
        },
        // 关闭标签
        closeSelectedTag(view) {
            if (this.visitedViews.length < 2) return;

            this.DelVisitedViews(view).then((views) => {
                if (this.isActive(view)) {
                    const latestView = views.slice(-1)[0];
                    if (latestView) this.$router.push(latestView.realPath);
                    else this.$router.push('/');
                }
            });
        },
        // // 关闭其他标签
        // closeOthersTags() {
        //     this.$router.push(this.selectedTag.realPath);
        //     this.DelOthersViews(this.selectedTag).then(() => {
        //         this.moveToCurrentTag();
        //     });
        // },
        // // 关闭所有标签
        // closeAllTags() {
        //     this.DelAllViews().then(() => {
        //         this.$router.push('/');
        //     });
        // },
        // // 打开自定义右键菜单
        // openMenu(tag, e) {
        //     this.visible = true;
        //     this.selectedTag = tag;
        //     this.left = e.pageX;
        //     this.top = e.pageY;
        // },
        // // 关闭自定义右键菜单
        // closeMenu() {
        //     this.visible = false;
        // },
    },
};
</script>
<style scoped lang="scss">
    .tags-view {
        height: 28px;
        margin-top: 4px;
        overflow: hidden;
        .tags-view-wrapper {
            height: 24px;
            .scroll-wrapper > .tags-view-item:nth-child(1) {
                margin-left: 0;
            }
            .tags-view-item {
                z-index: 1;
                display: inline-block;
                position: relative;
                height: 28px;
                line-height: 30px;
                font-size: 12px;
                @include font_color(text_color_base);
                padding: 0 28px;
                margin: 0 -13px;
                box-sizing: border-box;
                border-radius: 4px;
                transition: color .5s;
                &:first-of-type {
                    margin-left: 15px;
                }
                &:hover {
                    text-decoration: none;
                    &:not(.is-active)::before, &:not(.is-active)::after {
                        @include bg_color(color_base_gray2);
                    }
                    &::after {
                        display: none;
                    }
                }
                &.is-active {
                    z-index: 2;
                    cursor: default;
                    &::before {
                        @include bg_color(color_base_white);
                    }
                }
                & .el-icon-close {
                    width: 15px;
                    height: 15px;
                    margin-left: 5px;
                    line-height: 15px;
                    @include font_size(text_weak_annotation);
                    @include font_color(color_base_gray8);
                    text-align: center;
                    border-radius: 50%;
                    transition: background-color .1s, color .1s;
                    cursor: pointer;
                    &:not(.disabled):hover {
                        @include bg_color(color_base_gray6);
                        @include font_color(text_color_white);
                    }
                }
                & .el-icon-close.disabled {
                    cursor: not-allowed;
                }
            }
            .tags-view-item::before {
                content: '';
                position: absolute;
                top: 0px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                z-index: -1;
                border-radius: 10px 10px 0px 0px;
                transform: scaleY(1.1) perspective(0.8em) rotateX(4deg);
                transform-origin: bottom;
                background-color: transparent;
                transition: background-color .5s, border-color .5s;
            }
            .tags-view-item:not(.is-active)::after {
                content: '';
                position: absolute;
                top: 8px;
                right: 11px;
                @include bg_color(color_base_gray5);
                width: 1px;
                height: 12px;
            }
        }
        .contextmenu {
            margin: 0;
            @include bg_color(color_base_white);
            z-index: 6;
            position: fixed;
            list-style-type: none;
            padding: 5px 0;
            border-radius: 4px;
            @include font_size(text_weak_annotation);
            box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
            li {
                margin: 0;
                padding: 7px 16px;
                cursor: pointer;
                &:hover {
                    @include bg_color(color_base_gray4);
                }
            }
        }
    }
</style>
